<script setup lang="ts">
    /**
     * There is no need to define props or emit events in the setup() function at the moment,
     * as most props and events are automatically passed down to the component.
     * These are called fallthrough attributes.
     *
     * @see https://vuejs.org/guide/components/attrs.html#fallthrough-attributes
     *
     * Basic HTML Attributes:
     * id, title, role, tabindex, draggable, contenteditable
     *
     *  CSS-related Attributes:
     * class (CSS classes applied to the root element)
     * style (inline CSS styling for the root element)
     *
     *  Layout & Dimension Attributes:
     * width, height, min-width, max-width, min-height, max-height
     *
     *  Event Listeners (via v-on):
     * Any event listeners added with v-on (e.g., @click, @input, @mouseenter, etc.)
     * Custom events also fall through if not specifically handled in the component
     *
     * Data Attributes:
     * Any data-* attributes, like data-test-id, data-user-id (useful for testing and tracking)
     */
</script>

<template>
    <app-button color="secondary" variant="outlined">
        <slot></slot>
    </app-button>
</template>

<style scoped lang="scss"></style>
